import { CustomParameterInstances } from "./CustomParameterInstances";
export function productInstanceKey(fulfillmentMethod, productInstance) {
    const customParamsKey = customParameterInstancesKey(productInstance.customParameterInstances);
    const commonModifiersKey = modifierInstancesKey(productInstance.commonModifierInstances);
    const partsKey = productInstancePartsKey(fulfillmentMethod, productInstance.parts);
    return `ProductInstance[${customParamsKey},${commonModifiersKey}][${partsKey}]`;
}
export function productInstancePartsKey(fulfillmentMethod, parts) {
    let result = [];
    switch (parts.type) {
        case "SinglePart":
            result.push(fulfillmentMethodKey(fulfillmentMethod));
            result.push(isSplitKey(false));
            result.push(productTypeIdKey(parts.part.productTypeId));
            result.push(modifierInstancesKey(parts.part.modifierInstances));
            break;
        case "Halves":
            result.push(fulfillmentMethodKey(fulfillmentMethod));
            result.push(isSplitKey(true));
            result.push(productTypeIdKey(parts.first.productTypeId));
            result.push(modifierInstancesKey(parts.first.modifierInstances));
            result.push(productTypeIdKey(parts.second.productTypeId));
            result.push(modifierInstancesKey(parts.second.modifierInstances));
    }
    return result.join(",");
}
function fulfillmentMethodKey(fulfillmentMethod) {
    var _a;
    return `fulfillmentMethod=${(_a = fulfillmentMethod === null || fulfillmentMethod === void 0 ? void 0 : fulfillmentMethod.toString()) !== null && _a !== void 0 ? _a : "null"}`;
}
function isSplitKey(isSplit) {
    var _a;
    return `splitToHalves=${(_a = isSplit.toString()) !== null && _a !== void 0 ? _a : "null"}`;
}
function productTypeIdKey(productTypeId) {
    return `productType_${productTypeId.toString()}`;
}
function customParameterInstancesKey(customParameterInstances) {
    const customParameterSet = CustomParameterInstances.toCustomParameterSet(customParameterInstances);
    return customParameterSet.choices.entries
        .map(([parameter, choiceId]) => `parameter_${parameter.id.toString()}=${choiceId.toString()}`)
        .raw.join(":");
}
function modifierInstancesKey(modifierInstances) {
    return modifierInstances.objects
        .map((modifierInstance) => `modifier_${modifierInstance.typeId.toString()}->` +
        modifierInstance.selectedItems
            .map((modifierItemInstance) => `${modifierItemInstance.typeId.toString()}=${modifierItemInstance.quantity.toString()}`)
            .raw.join("|"))
        .raw.join(":");
}
